import axiosClient from './axiosClient'

const landingApi = {
  createRequireContact: (data) => {
    const url = '/create-require-contact'
    return axiosClient.post(url, data)
  },
  createRequireGroup: (data) => {
    const url = '/create-require-group'
    return axiosClient.post(url, data)
  },
}

export default landingApi
